import { css } from '@inter-ikea-kompis/web-component';
/**
 * A class with style.
 */
export default class OpenDesignCodeStyle {
    /**
     * Returns styles.
     *
     * @param options ...
     * @param options.theme ...
     * @returns Styles.
     */
    static getStyle(options) {
        const theme = options.theme;
        return css `
			:host {
				display: block;
			}

			.container {
				display: flex;
				flex-direction: column;
				align-items: flex-start;
			}

			skapa-button {
				margin-top: ${theme.spacing.space100 / 16}rem;
			}

			skapa-inline-message {
				margin-top: ${theme.spacing.space75 / 16}rem;
			}
		`;
    }
}
//# sourceMappingURL=OpenDesignCodeStyle.js.map